// extracted by css-extract-rspack-plugin
export default {"colorModeToggle":"colorModeToggle_x44X"};